function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  role: "img"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#212121",
  fillRule: "evenodd",
  d: "M20.348 5.348a.494.494 0 0 0-.702.006L9 16l-4.64-4.64a.5.5 0 0 0-.708-.012l-1.304 1.304a.5.5 0 0 0 .009.705L8.29 19.29a1.007 1.007 0 0 0 1.418.002L21.652 7.348a.493.493 0 0 0 0-.696z"
}));
export default "/Users/mgomezlucero/Work/SkedGo/Projects/tripkit-react/src/images/ic-tick.svg";
export { SvgComponent as ReactComponent };